import React from "react";
import cls from "./styles.module.scss";

const SECTORS = [1.1, 1.25, 1.5, 1.75, 2, 3];
const CENTER = 200;
const RADIUS = 188;

const polarToCartesian = (angle: number, radius: number) => {
  const radians = ((angle - 90) * Math.PI) / 180;

  return {
    x: CENTER + radius * Math.cos(radians),
    y: CENTER + radius * Math.sin(radians),
  };
};

const createSectorPath = (startAngle: number, endAngle: number) => {
  const start = polarToCartesian(startAngle, RADIUS);
  const end = polarToCartesian(endAngle, RADIUS);
  const largeArcFlag = endAngle - startAngle > 180 ? 1 : 0;

  return [
    `M ${CENTER} ${CENTER}`,
    `L ${start.x} ${start.y}`,
    `A ${RADIUS} ${RADIUS} 0 ${largeArcFlag} 1 ${end.x} ${end.y}`,
    "Z",
  ].join(" ");
};

export const GoalMultiplierMiniWheel = () => {
  const sectorAngle = 360 / SECTORS.length;

  return (
    <div className={cls.miniWheel} aria-hidden>
      <svg className={cls.miniWheelSvg} viewBox="0 0 400 400">
        <g className={cls.miniWheelSectors}>
          {SECTORS.map((value, index) => {
            const startAngle = index * sectorAngle;
            const endAngle = startAngle + sectorAngle;

            return (
              <path
                key={value}
                className={
                  index % 2 === 0 ? cls.miniWheelSectorDark : cls.miniWheelSectorLight
                }
                d={createSectorPath(startAngle, endAngle)}
              />
            );
          })}
        </g>
        <image
          className={cls.miniWheelPin}
          href="/goals/wheelCenter.webp"
          x="76"
          y="76"
          width="248"
          height="248"
          preserveAspectRatio="xMidYMid meet"
        />
      </svg>
    </div>
  );
};
